import Vuex from 'vuex'
import * as app from '@/store/app'
import * as appointment from '@/store/appointment'
import * as auth from '@/store/auth'
import * as company from '@/store/company'
import * as data from '@/store/data'
import * as filter from '@/store/filter'
import * as hospital from '@/store/hospital'
import * as legacy from '@/store/legacy'
import * as notification from '@/store/notification'
import * as order from '@/store/order'
import * as payment from '@/store/payment'
import * as room from '@/store/room'
import * as schedule from '@/store/schedule'
import * as talk from '@/store/talk'
import * as talker from '@/store/talker'
import * as user from '@/store/user'

export interface RootState {
  app: app.IAppState
  appointment: appointment.IAppointmentState
  auth: auth.IAuthState
  company: company.ICompanyState
  data: data.IDataState
  filter: filter.IFilterState
  hospital: hospital.IHospitalState
  legacy: legacy.ILegacyState
  notification: notification.INotificationState
  order: order.IOrderState
  payment: payment.IPaymentState
  room: room.IRoomState
  schedule: schedule.IScheduleState
  talk: talk.ITalkState
  talker: talker.ITalkerState
  user: user.IUserState
}

const createStore = () => {
  return new Vuex.Store<RootState>({
    modules: {
      app: app.store,
      appointment: appointment.store,
      auth: auth.store,
      company: company.store,
      data: data.store,
      filter: filter.store,
      hospital: hospital.store,
      legacy: legacy.store,
      notification: notification.store,
      order: order.store,
      payment: payment.store,
      room: room.store,
      schedule: schedule.store,
      talk: talk.store,
      talker: talker.store,
      user: user.store
    }
  })
}
export default createStore
